import { call, put, take, takeEvery } from "redux-saga/effects";
import Swal from "sweetalert2";
import * as types from "./stateLicenseActionType";
import * as actions from "./stateLicenseActions";
import * as services from "./stateLicenseServices";

const getStateLicenseList = (response) => {
  const values =
    response?.values ||
    response?.value ||
    response?.Values ||
    response?.Value ||
    {};

  if (Array.isArray(values)) {
    return values;
  }

  return (
    values?.lstStateLicense ||
    values?.LstStateLicense ||
    values?.stateLicenseList ||
    values?.StateLicenseList ||
    []
  );
};

function* fetchStateLicenseSaga() {
  try {
    const response = yield call(services.getAllStateLicense);

    if (response?.success) {
      const list = getStateLicenseList(response);
      yield put(actions.fetchStateLicenseSuccess(list));
    } else {
      yield put(actions.fetchStateLicenseFailure("No data found"));
    }
  } catch (error) {
    console.error("State License Fetch Error:", error);
    yield put(
      actions.fetchStateLicenseFailure("Failed to fetch State License list"),
    );
    Swal.fire("Error", "Failed to load State License list", "error");
  }
}

function* fetchStateLicenseNotesSaga(action) {
  try {
    const response = yield call(
      services.getStateLicenseNotesByDetailsId,
      action.payload,
    );

    if (response?.success) {
      const notes =
        response?.value ||
        response?.Value ||
        response?.values ||
        response?.Values ||
        [];
      yield put(actions.fetchStateLicenseNotesSuccess(Array.isArray(notes) ? notes : []));
    } else {
      yield put(actions.fetchStateLicenseNotesFailure("No notes found"));
    }
  } catch (error) {
    console.error("State License Notes Fetch Error:", error);
    yield put(actions.fetchStateLicenseNotesFailure("Failed to fetch notes"));
  }
}

function* addStateLicenseNoteSaga(action) {
  try {
    const response = yield call(services.addStateLicenseNote, action.payload);

    if (response?.success) {
      yield put(actions.addStateLicenseNoteSuccess(
        action.payload.Notes,
        action.payload.Provider_StateLicenseDetailsId,
      ));
      yield put(
        actions.fetchStateLicenseNotesRequest({
          stateLicenseDetailsId: action.payload.Provider_StateLicenseDetailsId,
        }),
      );
      yield take([types.FETCH_STATE_LICENSE_NOTES_SUCCESS, types.FETCH_STATE_LICENSE_NOTES_FAILURE]);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response?.resultMessage || "Note added successfully!",
        timer: 3000,
        showConfirmButton: false,
      });
    } else {
      yield put(actions.addStateLicenseNoteFailure("Failed to save note"));
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response?.errorMessage || "Failed to save note.",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  } catch (error) {
    console.error("Add State License Note Error:", error);
    yield put(actions.addStateLicenseNoteFailure("Failed to save note"));
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "An unexpected error occurred while saving the note.",
      timer: 2000,
      showConfirmButton: false,
    });
  }
}

export default function* watchStateLicenseSaga() {
  yield takeEvery(types.FETCH_STATE_LICENSE_REQUEST, fetchStateLicenseSaga);
  yield takeEvery(types.FETCH_STATE_LICENSE_NOTES_REQUEST, fetchStateLicenseNotesSaga);
  yield takeEvery(types.ADD_STATE_LICENSE_NOTE_REQUEST, addStateLicenseNoteSaga);
}
